// extracted by mini-css-extract-plugin
export default {"container":"AntiBriberyPolicyPage_container__OKtSd"};